import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';

import { CanvasElementId } from '@blaze-runtime/engine-domain';

export type ItemAddMessage = { elementId: CanvasElementId; path: string };

@Injectable({ providedIn: 'root' })
export class CollectionListBusService {
  private itemAdd$ = new Subject<ItemAddMessage>();

  postItemAdd(message: ItemAddMessage): void {
    this.itemAdd$.next(message);
  }

  getItemAdd$(): Observable<ItemAddMessage> {
    return this.itemAdd$.asObservable();
  }
}
